import normalizeModifiers from './normalizeModifiers';
import log from '../../log';

function typeInterceptor(fn, type, position) {
	return {fn, type, position};
}

function mapInterceptors(interceptors) {
	const mapped = {before: [], after: []};
	const {length: interceptorCount} = interceptors;
	for (let i = 0; i < interceptorCount; i++) {
		const interceptor = interceptors[i];
		const {before, after} = interceptor;
		if (!before && !after) {
			mapped.before.push(typeInterceptor(interceptor));
			continue;
		}
		if (before) mapped.before.push(typeInterceptor(before, 'before', mapped.before.length));
		if (after) mapped.after.unshift(typeInterceptor(after, 'after', mapped.after.length));
	}

	return mapped;
}

function normalizeHandlers(handlers, tagName) {
	if (handlers.length) {
		log(`Please update action handler definition in <${tagName}>`, {
			tagName,
			origin: 'normalizeHandlers',
			docs: 'https://developer.servicenow.com/dev.do#!/guide/orlando/now-experience/ui-framework/now-experience-ui-framework-101/action-handlers'
		});
	}

	return handlers.map(handler =>
		typeof handler === 'function'
			? {
					effect: handler,
					args: []
			  }
			: {
					...handler,
					effect: handler.effect || handler.fn,
					args: handler.args || []
			  }
	);
}

export function normalizeActionHandler(actionHandler, tagName) {
	const {
		handlers = [],
		args = [],
		interceptors = [],
		stopPropagation,
		private: isPrivate,
		target,
		modifiers = [],
		modifier = {},
		capture = false,
		eventHandler = false,
		descendantOnly = false
	} = actionHandler;

	if (typeof actionHandler === 'function') {
		return {
			stopPropagation,
			effect: actionHandler,
			handlers: [],
			args,
			interceptors: mapInterceptors(interceptors),
			target,
			modifier: normalizeModifiers(modifiers, modifier),
			capture,
			eventHandler,
			descendantOnly
		};
	}

	function effectDelegate(...args) {
		// Effect delegate function to enable stubbing in tests
		return actionHandler.effect(...args);
	}

	return {
		stopPropagation: stopPropagation || isPrivate,
		effect: typeof actionHandler.effect === 'function' ? effectDelegate : actionHandler.effect,
		handlers: normalizeHandlers(handlers, tagName),
		args,
		interceptors: mapInterceptors(interceptors),
		target,
		modifier: normalizeModifiers(modifiers, modifier),
		capture,
		eventHandler,
		descendantOnly
	};
}
